"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var component_button_1 = __importDefault(require("@doordash/component-button"));
var component_fields_1 = require("@doordash/component-fields");
var component_layer_manager_1 = require("@doordash/component-layer-manager");
var component_loading_1 = __importDefault(require("@doordash/component-loading"));
var design_language_1 = require("@doordash/design-language");
var get_1 = __importDefault(require("lodash/get"));
var isNil_1 = __importDefault(require("lodash/isNil"));
var React = __importStar(require("react"));
var App_1 = __importDefault(require("../App/App"));
var enums_1 = require("../Common/utils/enums");
var i18n_1 = require("../i18n/i18n");
var HelpDropdown_1 = __importDefault(require("./HelpDropdown"));
/* tslint:disable-next-line:max-line-length */
var GeneratePasscodeMutation_1 = __importDefault(require("./Providers/GeneratePasscodeMutation"));
var VerifyPasscodeMutation_1 = __importDefault(require("./Providers/VerifyPasscodeMutation"));
var TwoFactorAuthenticationStrings_1 = __importDefault(require("./TwoFactorAuthenticationStrings"));
var TwoFactorAuthenticationUtils_1 = require("./TwoFactorAuthenticationUtils");
var VerifyAccountContext_1 = __importDefault(require("./VerifyAccountContext"));
var verifyAccountTracking = __importStar(require("./VerifyAccountTracking"));
var VerifyPasscode = function () {
    var _a = __read(React.useState(''), 2), code = _a[0], setCode = _a[1];
    var _b = __read(React.useState(''), 2), error = _b[0], setError = _b[1];
    var _c = __read(React.useState(false), 2), showHelp = _c[0], setShowHelp = _c[1];
    var _d = React.useContext(App_1["default"]), client = _d.client, dispatch = _d.dispatch, experience = _d.experience, state = _d.state;
    var _e = React.useContext(VerifyAccountContext_1["default"]), action = _e.action, blockChannelSwitch = _e.blockChannelSwitch, channel = _e.channel, setAccountBlocked = _e.setAccountBlocked;
    var isRestClient = isNil_1["default"](client);
    var experienceStrings = i18n_1.getStringsForExperience(TwoFactorAuthenticationStrings_1["default"], experience);
    var submitPasscode = function (verifyPasscode) {
        setError('');
        verifyAccountTracking.trackOnClick(state.workflow);
        verifyPasscode(code, action)
            .then(function () {
            verifyAccountTracking.trackOnSuccess(state.workflow);
            dispatch({ type: enums_1.RiskActions.Reset });
            if (state.onSuccess) {
                state.onSuccess();
            }
            return false;
        })["catch"](function (err) {
            if (TwoFactorAuthenticationUtils_1.isUserBlocked(isRestClient, err)) {
                verifyAccountTracking.trackOnFailure(state.workflow, 'blocked');
                setAccountBlocked(true);
            }
            else if (TwoFactorAuthenticationUtils_1.triesRemaining(isRestClient, err) > 0) {
                verifyAccountTracking.trackOnFailure(state.workflow, 'wrong code');
                setError(experienceStrings.wrongCodeNumTriesRemaining(TwoFactorAuthenticationUtils_1.triesRemaining(isRestClient, err)));
            }
            else {
                setError(experienceStrings.errorProcessingTryAgain());
            }
        });
    };
    return (React.createElement(GeneratePasscodeMutation_1["default"], null, function (generatePasscode, res) {
        if (!res.called) {
            generatePasscode(channel, action);
        }
        if (TwoFactorAuthenticationUtils_1.isUserBlocked(isRestClient, res.error)) {
            setAccountBlocked(true);
        }
        var passcodeRes = get_1["default"](res, 'data.generatePasscode');
        return passcodeRes ? (React.createElement(design_language_1.StackChildren, null,
            React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageSubtext, textAlign: design_language_1.Text.TextAlignments.Center }, experienceStrings.forSecurityIsYou()),
            React.createElement(component_fields_1.TextField, { autoFocus: true, label: experienceStrings.enterCode(), value: code, error: error, onChange: function (value) { return setCode(value); } }),
            React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageDescriptionBody, textAlign: design_language_1.Text.TextAlignments.Center }, experienceStrings.messageWithCodeWasSent(passcodeRes.channel === enums_1.TwoFactorChannels.SMS
                ? experienceStrings.aTextMessage()
                : experienceStrings.anEmail(), passcodeRes.contactAddress)),
            React.createElement(VerifyPasscodeMutation_1["default"], null, function (verifyPasscode, verifyRes) { return (React.createElement(component_button_1["default"], { isDisabled: !code, state: verifyRes.loading
                    ? component_button_1["default"].States.Loading
                    : component_button_1["default"].States.Default, onClick: function () { return submitPasscode(verifyPasscode); } }, experienceStrings.verify())); }),
            React.createElement(design_language_1.InlineChildren, { size: design_language_1.InlineChildren.Sizes.XxSmall, alignItems: design_language_1.InlineChildren.Alignment.Center },
                React.createElement(component_button_1["default"], { isInline: true, padding: component_button_1["default"].Padding.None, type: component_button_1["default"].Types.FlatPrimary, onClick: function () {
                        verifyAccountTracking.trackOnResendCode(state.workflow);
                        generatePasscode(channel, action);
                    } }, experienceStrings.resendCode()),
                React.createElement("div", null, "\u2022"),
                React.createElement(component_layer_manager_1.AnchoredLayer, { offset: [
                        component_layer_manager_1.AnchoredLayer.Offset.None,
                        component_layer_manager_1.AnchoredLayer.Offset.XSmall,
                    ], position: component_layer_manager_1.AnchoredLayer.Positions.BottomCenter, content: showHelp && (React.createElement(HelpDropdown_1["default"], { generatePasscode: generatePasscode, channel: channel, action: action, blockChannelSwitch: blockChannelSwitch, trackChannelSwitch: function () {
                            return verifyAccountTracking.trackOnChannelSwitch(state.workflow);
                        }, trackHelpClick: function () {
                            return verifyAccountTracking.trackContactSupport(state.workflow);
                        }, closeDropdown: function () { return setShowHelp(false); } })) },
                    React.createElement(component_button_1["default"], { isInline: true, padding: component_button_1["default"].Padding.None, type: component_button_1["default"].Types.FlatPrimary, onClick: function () { return setShowHelp(!showHelp); } }, experienceStrings.getHelp()))))) : (React.createElement(component_loading_1["default"], { size: component_loading_1["default"].Sizes.Large }));
    }));
};
exports["default"] = VerifyPasscode;
